var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "286px",
    height: "286px",
    viewBox: "0 0 286 286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spotify") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spotify"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(10.000000, 5.000000)",
    fill: "#40DD78"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 137.5,
    cy: 137.5,
    r: 137.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.508266,194.533017 C199.339608,198.402016 196.113663,198.882274 192.611002,196.720662 C177.302409,187.245656 159.826059,180.978058 140.939993,178.917884 C121.548267,176.804746 102.733407,179.363133 85.4878043,185.669331 C83.6382262,186.348874 79.7326601,186.308478 78.5194379,180.928685 C77.3053143,175.539916 80.3536929,172.905227 82.0139866,172.313656 C100.816227,165.578367 121.258031,162.821594 142.337091,165.11696 C163.049301,167.375521 182.565414,173.626961 198.995291,184.599297 C201.585782,186.330023 203.674219,190.661326 201.508266,194.533017 Z M215.034882,163.653742 C213.60173,165.331505 211.524109,166.379097 209.209433,166.127747 C208.56857,166.057728 208.007027,165.779447 207.440075,165.544255 C188.63513,154.364556 167.377602,146.921896 144.43364,144.420961 C121.660035,141.943365 99.5245873,144.577157 79.0160838,151.344762 C78.2814804,151.528786 77.5261459,151.673313 76.7320532,151.586238 C74.3741116,151.329502 72.5254349,149.807935 71.4717523,147.798928 L70.5803134,143.594198 C70.8155667,141.48914 71.9494698,139.765595 73.5016011,138.623747 C96.1219767,130.929736 120.617168,127.871343 145.835245,130.618242 C171.04521,133.363345 194.376754,141.613019 214.956465,154.026131 C216.275145,155.460622 217.008847,157.440903 216.833083,159.551347 L215.034882,163.653742 Z M68.8875709,96.5809307 C94.5139614,88.9766882 121.904301,86.1507934 150.030146,89.2172663 C177.900908,92.2541158 203.903163,100.776684 227.269859,113.539891 C230.394853,115.642256 232.358903,119.325434 231.945182,123.428727 C231.355696,129.244792 226.326142,133.456704 220.725129,132.848077 C219.940951,132.761003 219.219868,132.500675 218.510503,132.240348 C197.184471,120.512167 173.411264,112.686197 147.9354,109.910573 C122.439706,107.130459 97.5974929,109.664608 74.3768157,116.563275 C73.6431137,116.65035 72.907609,116.743708 72.1405569,116.658429 C66.5404455,116.047109 62.4672276,110.842364 63.056713,105.028992 C63.4442952,101.201287 65.7643799,98.0998043 68.8875709,96.5809307 Z",
    id: "Spotify",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotify);
export default __webpack_public_path__ + "static/media/spotify.fb7a4921e28311a1f23d394125b48a85.svg";
export { ForwardRef as ReactComponent };